import { Typography, Stack, Divider } from "@mui/material"
import {FontSubtitleTwo, FontSubtitleThree} from "../../../components/SharedTypography";
import {Client, ClientFields} from "../../../../../types/client/clientData";
import {dateFormatter} from "../../../../../utils/formatters";

const TEXTOS = {
    ACTIVIDAD_EMPRESA: "Actividad",
    ACTIVIDAD_PRINCIPAL: "Actividad Principal",
    FECHA_INSCRIPCION_AFIP: "Fecha de inscripción en AFIP",
    AÑO_INICIO_ACTIVIDAD: "Año de inicio de actividades"
}

interface CompanyActivityProps {
    client: Client
}

const CompanyActivity = ({client}: CompanyActivityProps) => {


    return (
        <Stack spacing={4}>
            <FontSubtitleTwo text={TEXTOS.ACTIVIDAD_EMPRESA} />
            <Divider />
            <Stack spacing={4}>
                <Stack direction='row' display='flex' justifyContent='space-between' alignItems='center'>
                    <FontSubtitleThree text={TEXTOS.ACTIVIDAD_PRINCIPAL} />
                    <Typography fontSize={14}>{client[ClientFields.AfipMainActivityDesc]}</Typography>
                </Stack>
                <Stack direction='row' display='flex' justifyContent='space-between' alignItems='center'>
                    <FontSubtitleThree text={TEXTOS.FECHA_INSCRIPCION_AFIP} />
                    <Typography fontSize={14}>{dateFormatter.toShortDate(client[ClientFields.AfipRegisterDate])}</Typography>
                </Stack>
                <Stack direction='row' display='flex' justifyContent='space-between' alignItems='center'>
                    <FontSubtitleThree text={TEXTOS.AÑO_INICIO_ACTIVIDAD} />
                    <Typography fontSize={14}>{dateFormatter.toYearDate(client[ClientFields.ActivityStartDate])}</Typography>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default CompanyActivity